//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            opts: [
                {
                    text: '一室',
                    selected: false
                },
                {
                    text: '二室',
                    selected: false
                },
                {
                    text: '三室',
                    selected: false
                },
                {
                    text: '四室',
                    selected: false
                },
                {
                    text: '五室',
                    selected: false
                },
                {
                    text: '五室以上',
                    selected: false
                }
            ],
            selected: ''
        }
    },
    onUnload () {
        this.reset()
    },
    methods: {
        onSelect (index) {
            const opt = this.opts[index]
            this.$set(this.opts, index, {
                ...opt,
                selected: !opt.selected
            })
        },
        reset () {
            this.opts.forEach((opt, i) => {
                opt.selected = false
            })
        },
        confirm () {
            this.$emit('change', this.opts.filter(({ selected, text }) => selected && text).map(({ text }) => text).join(','))
        }
    },
    props: {
        show: {
            type: Boolean
        }
    }
}
